import { readCookie, writeCookie } from "../../../root/punks/utils/cookies"

const PREVIEW_MODE_TOKEN_COOKIE_NAME = "preview-token"

export const readPrivateModeCookie = () =>
  readCookie(PREVIEW_MODE_TOKEN_COOKIE_NAME)

export const writePrivateModeCookie = (value: string, expiration?: Date) =>
  writeCookie(PREVIEW_MODE_TOKEN_COOKIE_NAME, value, expiration)
